<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <a-button type="default" slot="extra" @click="handleBack">返回</a-button>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                :wrapper-col="wrapperCol">

                <a-form-model-item label="KA环境编码">
                    <span>{{record.kadesc + ' - ' + record.kaenv}}</span>
                </a-form-model-item>

                <a-form-model-item label="中间件类型" ref="middlewaretype" prop="middlewaretype">
                    <a-select v-if="is_vue_task" v-model="record.middlewaretype"  style="width:150px;" @change="handleTypeChange">
                        <a-select-option v-for="(value,name) in typeNames" :key="name" :value="value">
                            {{name}}
                        </a-select-option>
                    </a-select>
                    <span v-else>{{typeNames[record.middlewaretype]}}</span>
                </a-form-model-item>

                <a-form-model-item label="参数类型" ref="configtype" prop="configtype">
                    <a-select v-if="is_vue_task" v-model="record.configtype"  style="width:200px;" >
                        <a-select-option v-for="(value,name) in configtypeNames[record.middlewaretype]" :key="name" :value="name">
                            {{name}}
                        </a-select-option>
                    </a-select>
                    <span v-else>{{configtypeNames[record.middlewaretype][record.configtype] + ' ： ' + record.configtype}}</span>
                </a-form-model-item>

                <a-form-model-item label="配置值" ref="configval" prop="configval">
                    <a-input v-if="is_vue_task" v-model="record.configval"></a-input>
                    <span v-else>{{record.configval}}</span>
                </a-form-model-item>

                <a-form-model-item label="描述" ref="desc" prop="desc">
                    <a-input v-if="is_vue_task" v-model="record.desc"></a-input>
                    <span v-else>{{record.desc}}</span>
                </a-form-model-item>


                <a-form-model-item v-show="is_vue_task" :wrapper-col="{ span: 14, offset: 8 }">
                    <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

        </a-card>
    </div>

</template>
<script>
let typeNames = {
    'rocketmq':'rocketmq',
    'zookeeper':'zookeeper',
    'redis':'redis',
}

let configtypeNames = {
    'zookeeper':{
        'dubbo.zookeeper.address.qt':'dubbo前台注册中心v5',
        'dubbo.zookeeper.address.zt':'dubbo中台注册中心v5',
        'dubbo.zookeeper.address.jt':'dubbo基础注册中心v5',
        'dubbo.zookeeper.address.v3':'dubbo注册中心v3',
        'dubbo.metadata.center':'dubbo元数据中心',
        'dubbo.config.center':'dubbo配置中心',
        'scm.address':'应用动态配置中心',
    },
    'rocketmq':{
        'rocketmq.address.qt': '前台mq',
        'rocketmq.address.zt': '中台mq',
        'rocketmq.address.jt':  '基础mq',
        'rocketmq.addres.v3': 'v3mq',
    },
    'redis':{
        'redis.address.qt':'前台缓存',
        'redis.address.zt':'中台缓存',
        'redis.address.jt':'基础缓存',
        'redis.address.v3':'v3缓存'
    }
}

const m_title = {
    'addMiddleware':'新增中间件',
    'editMiddleware':'编辑中间件',
    'detailMiddleware':'中间件详情'
};

export default {
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            typeNames,
            configtypeNames,
            rules: {
                middlewaretype: [
                    { required: true, message: ' 请选择中间件类型', trigger: 'blur' },
                ],
                configtype:[
                    { required: true, message: ' 请选择参数类型', trigger: 'blur' },
                ],
                configval:[
                    { required: true, message: ' 请填写配置值', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                kadesc:'',
                kaenv:'',
                middlewaretype:'rocketmq',//中间件类型
                configtype:"",//参数类型
                configval:'',//配置值
                desc:'',//描述
            },

        };
    },
    computed: {

    },
    components:{

    },
    methods: {
        handleTypeChange(){
            this.record.configtype = '';
        },
        handleBack(){
            this.$router.push({
                path:'middleware',
                query:{
                    kaenv:this.record.kaenv
                }
            })
        },
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    const { params } = that.$route;
                    that.record.domain = that.record.before + that.record.after;
                    if(params.action == 'editMiddleware'){
                        that.$store
                            .dispatch({
                                type: "kamanager/updateMiddleware",
                                params: {
                                    ...that.record,
                                    operateuser:this.G.getCurrentUser().username,
                                    urlparams: false,
                                }
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'addMiddleware'){
                        that.record.id = '';
                        //新增
                        that.$store
                            .dispatch({
                                type: "kamanager/addMiddleware",
                                params: {
                                    ...that.record,
                                    createuser:this.G.getCurrentUser().username,
                                    urlparams: false,
                                }
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.resetForm();
            
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

        getDetail(query){
            let that = this;
            that.$store.dispatch({
                type: "kamanager/queryMiddleware",
                params: {
                    id:query.id
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.record = {
                        ...result
                    }
                    this.record.kadesc = query.kadesc

                    
                }
            });
        }
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "addMiddleware";
        this.is_vue_task = params.action != "detailMiddleware"
        //初始化值
        this.record.kaenv = query.kaenv;
        this.record.kadesc = query.kadesc
        this.record.id = query.id;
        if (!this.is_new) {
            this.getDetail(query)
        }
        else{
            this.resetForm();
        }
        
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
